import { render, staticRenderFns } from "./productMarkingSettings.vue?vue&type=template&id=4a9af8c6&scoped=true&"
import script from "./productMarkingSettings.vue?vue&type=script&lang=js&"
export * from "./productMarkingSettings.vue?vue&type=script&lang=js&"
import style0 from "./productMarkingSettings.vue?vue&type=style&index=0&id=4a9af8c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9af8c6",
  null
  
)

export default component.exports